export const API_KEY: string = "pk.eyJ1IjoicmVhbGl0eWdhbWVzIiwiYSI6ImNrd2V3ejJsdDA5MmsybnF2djF2Z2I0NWoifQ.XKFFjpeHqmI1QOv7nC3kDg";
export const MAP_STYLE: string = "mapbox://styles/realitygames/ckyhqe8n587dr14nuq457i645"; 